const NewZealandValidation = {
  'ez-mail': /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  'required-phone-mask': /^(?:(\+64)|(0)) ?([34679]) ?\d{3,4} ?\d{4,5}$|^(?:(\+64)|(0)) ?[589]\d{2} ?\d{3,4} ?\d{3,4}$/,
  'optional-phone-mask': /^$|^(?:(\+64)|(0)) ?([34679]) ?\d{3,4} ?\d{4,5}$|^(?:(\+64)|(0)) ?[589]\d{2} ?\d{3,4} ?\d{3,4}$/,
  'mobile-mask': /^(?:(\+64|0)) ?(20|21|22|27|28|29) ?\d{3,4} ?\d{3,4}$/,
  'mobile-and-phone-mask':/^(?:(\+64|0)) ?(20|21|22|27|28|29) ?\d{3,4} ?\d{4,5}$|^(?:(\+64)|(0)) ?([34679]) ?\d{3,4} ?\d{4,5}$|^(?:(\+64)|(0)) ?[589]\d{2} ?\d{3,4} ?\d{3,4}$/,
};

export default NewZealandValidation;
